export const EDGELESS_TOP_CONTENTEDITABLE_SELECTOR =
  'hive-edgeless-note .edgeless-note-page-content, hive-edgeless-text';
